import {EncodeObject, GeneratedType} from "@shareledgerjs/signing";
import {Grant} from "@shareledgerjs/types/cosmos/authz/v1beta1/authz";
import {MsgExec, MsgGrant, MsgRevoke} from "@shareledgerjs/types/cosmos/authz/v1beta1/tx";
import {Any} from "@shareledgerjs/types/google/protobuf/any";

import {BaseClient} from "../../baseclient";

export function createAuthzTypes(): ReadonlyArray<[string, GeneratedType]> {
  return [
    ["/cosmos.authz.v1beta1.MsgExec", MsgExec],
    ["/cosmos.authz.v1beta1.MsgGrant", MsgGrant],
    ["/cosmos.authz.v1beta1.MsgRevoke", MsgRevoke]
  ];
}

export interface MsgExecEncodeObject extends EncodeObject {
  readonly typeUrl: "/cosmos.authz.v1beta1.MsgExec";
  readonly value: Partial<MsgExec>;
}

export interface MsgGrantEncodeObject extends EncodeObject {
  readonly typeUrl: "/cosmos.authz.v1beta1.MsgGrant";
  readonly value: Partial<MsgGrant>;
}

export interface MsgRevokeEncodeObject extends EncodeObject {
  readonly typeUrl: "/cosmos.authz.v1beta1.MsgRevoke";
  readonly value: Partial<MsgRevoke>;
}

export interface AuthzTxExtensionMethods {
  exec(grantee: string, msgs: Any[]): MsgExecEncodeObject;
  grant(granter: string, grantee: string, grant: Grant): MsgGrantEncodeObject;
  revoke(granter: string, grantee: string, msgTypeUrl: string | undefined): MsgRevokeEncodeObject;
}

export interface AuthzTxExtension {
  readonly authz: AuthzTxExtensionMethods;
}

export function AuthzTxExtension<T extends {new (...args: any[]): BaseClient & AuthzTxExtension}>(constructor: T): T {
  return class extends constructor {
    override get authz() {
      return {
        ...super["authz"],
        exec: (grantee: string, msgs: Any[]): MsgExecEncodeObject => {
          return {
            typeUrl: "/cosmos.authz.v1beta1.MsgExec",
            value: MsgExec.fromPartial({grantee, msgs})
          };
        },
        grant: (granter: string, grantee: string, grant: Grant): MsgGrantEncodeObject => {
          return {
            typeUrl: "/cosmos.authz.v1beta1.MsgGrant",
            value: MsgGrant.fromPartial({granter, grantee, grant})
          };
        },
        revoke: (granter: string, grantee: string, msgTypeUrl: string | undefined): MsgRevokeEncodeObject => {
          return {
            typeUrl: "/cosmos.authz.v1beta1.MsgRevoke",
            value: MsgRevoke.fromPartial({grantee, granter, msgTypeUrl})
          };
        }
      };
    }
  };
}
